import { EConclusion } from '../../types/calculate';

export const TYPE_TO_ICON_CLASS_MAP: { [key in EConclusion]: string } = {
  [EConclusion.MortgageProfitable]: 'hands',
  [EConclusion.DepositProfitable]: 'think',
  [EConclusion.DepositOnly]: 'think',
  [EConclusion.NotEnoughMoney]: 'think',
  [EConclusion.InadequateMortgagePayment]: 'think',
  [EConclusion.EnoughMoney]: 'ok',
  [EConclusion.MortgageNoSense]: 'do_not_know',
  [EConclusion.NotMatter]: 'do_not_know',
  [EConclusion.EmptyInput]: 'do_not_know',
};
